import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from "@material-ui/core";
import React, { ReactNode } from "react";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useTranslation } from "../../../../hooks/useTranslation";
import { useAccordionCardStyles } from "./AccordionCard.styles";

type AccordionCardProps = {
  id?: string;
  titleKey: string;
  subtitleKey?: string;
  contentKey?: string;
  number?: number;
  icon?: ReactNode;
  colorVariant?: "blue" | "red" | "green" | "pink" | "purple" | "orange" | "gray" | "gradient";
  children?: React.ReactNode;
  expanded?: boolean;
  className?: string;
  style?: React.CSSProperties;
};

const AccordionCard = ({
  id,
  titleKey,
  subtitleKey,
  contentKey,
  number,
  icon,
  colorVariant = "gradient",
  children,
  expanded,
  className,
  style,
}: AccordionCardProps) => {
  const classes = useAccordionCardStyles();
  const { t } = useTranslation();

  const [isExpanded, setIsExpanded] = React.useState<boolean>(expanded ?? false);

  const handleChange = () => (event: React.ChangeEvent<{}>, newExpanded: boolean) => {
    setIsExpanded(newExpanded);
  };

  return (
    <Accordion
      id={id}
      square
      className={`${classes.root} ${className || ""}`}
      style={style}
      expanded={isExpanded}
      onChange={handleChange()}
    >
      <AccordionSummary
        className={classes.acordionSummary}
        expandIcon={<ExpandMoreIcon className={classes.icon} />}
        aria-controls="panel1a-content"
        id={id}
      >
        <Box className={classes.header}>
          {number && <Box className={`${classes.badge} ${classes[colorVariant]}`}>{number}</Box>}
          {icon && <Box className={`${classes.badge} ${classes[colorVariant]}`}>{icon}</Box>}
          <Box>
            {titleKey ? <Typography className={classes.heading}>{t(titleKey)}</Typography> : null}
            {subtitleKey ? (
              <Typography className={classes.subtitle} variant="h6">
                {t(subtitleKey)}
              </Typography>
            ) : null}
          </Box>
        </Box>
      </AccordionSummary>
      <AccordionDetails
        className={classes.details}
        id="panel1a-content"
        aria-labelledby="panel1a-header"
      >
        <Box width="100%">
          {children}
          {!children && contentKey ? t(contentKey) : null}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default AccordionCard;
